import { render } from "./PatientsTable.vue?vue&type=template&id=3b76a3c8"
import script from "./PatientsTable.vue?vue&type=script&lang=js"
export * from "./PatientsTable.vue?vue&type=script&lang=js"

import "./PatientsTable.vue?vue&type=style&index=0&id=3b76a3c8&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__